import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { TurnAdminState } from './types';

const initialState: TurnAdminState = {
  isLoading: false,
};

export const TurnAdminSlice = createSlice({
  name: 'turnAdmin',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setIsLoading } = TurnAdminSlice.actions;

export default TurnAdminSlice.reducer;
